import React from 'react';
import { capitalize } from 'lodash';

import EnrollmentStatusBadge from '../components/EnrollmentStatusBadge';
import RadioSelectCell from '../components/RadioSelectCell';
import RowActions from '../components/RowActions';

const cellClass = '!flex !items-center';

export const getColumns = ({ onEnroll, onUnenroll, isAdmin } = {}) => {
  const baseColumns = [
    {
      field: 'selection',
      headerName: '',
      width: 56,
      cellRenderer: RadioSelectCell,
      cellClass: '!flex !justify-center !items-center',
      sortable: false,
      suppressMenu: true,
      resizable: false
    },
    {
      field: 'name',
      headerName: 'Name',
      cellClass,
      valueGetter: ({ data }) =>
        `${capitalize(data?.f_name || '')} ${capitalize(data?.l_name || '')}`.trim(),
      flex: 1
    },
    {
      field: 'kind',
      headerName: 'Role',
      cellClass,
      valueFormatter: ({ value }) => capitalize(value || ''),
      flex: 1
    },
    {
      field: 'email',
      headerName: 'Email',
      cellClass,
      flex: 1.5
    },
    {
      field: 'status',
      headerName: 'Status',
      cellClass,
      cellRenderer: ({ data }) => <EnrollmentStatusBadge isEnrolled={!!data?.veradigm_user_id} />,
      flex: 1
    },
    {
      field: 'actions',
      headerName: 'Actions',
      cellClass,
      cellRenderer: ({ data }) => (
        <RowActions data={data} onEnroll={onEnroll} onUnenroll={onUnenroll} />
      ),
      width: 120,
      sortable: false
    }
  ];

  return baseColumns;
};

export const DEFAULT_COLUMNS = getColumns();
